module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isResouceExist) ? _c('div', {
    staticClass: "outdata"
  }, [_vm._v("\n  该页面已停止访问\n")]) : _vm._e(), _vm._v(" "), (_vm.isResouceExist) ? _c('div', [_c('div', {
    ref: "top-box",
    staticClass: "top-box"
  }, [(_vm.navs2) ? _c('headerImg', {
    attrs: {
      "fixed": _vm.fixedStatus,
      "flag1": _vm.tmpHeaderTextFl * 1,
      "baseInfo": _vm.baseInfo,
      "color": _vm.color,
      "tmpRegisterFl": _vm.tmpRegisterFl,
      "navs2": _vm.navs2,
      "isregister": _vm.isregister,
      "url": _vm.bannerImg,
      "slides": _vm.slides
    },
    on: {
      "login": _vm.login,
      "loaded": function($event) {
        _vm.imgload = true
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "50px",
      "margin-top": "-25px"
    }
  }, [(_vm.navs2) ? _c('i-nav', {
    attrs: {
      "color": _vm.color,
      "navs": _vm.navs
    },
    on: {
      "closeSearch": function($event) {
        _vm.search = 0
      },
      "fixemit": _vm.fixemit
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.search),
      expression: "!search"
    }]
  }, _vm._l((_vm.componentsList), function(item, i) {
    return _c('div', {
      key: i,
      staticStyle: {
        "width": "1000px",
        "margin": "0 auto"
      },
      attrs: {
        "id": ("id_" + (item.navId))
      }
    }, [(!item.navUrl && item.navType != 6) ? _c('top-bar', {
      attrs: {
        "color": _vm.color,
        "data": item,
        "text": item.navName
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((item.comps), function(c, j) {
      return (item.navType != 6) ? _c('div', {
        key: j
      }, [(item.comps.length > 1 && c.cpnCode != 'cal' && c.cpnCode != 'live') ? _c('secondTitle', {
        staticStyle: {
          "margin-top": "5px"
        },
        attrs: {
          "color": _vm.color,
          "name": c.cpnTitle
        }
      }) : _vm._e(), _vm._v(" "), (c.cpnCode === 'def') ? _c('div', {
        staticClass: "v-html",
        staticStyle: {
          "margin-top": "10px",
          "margin-left": "20px"
        },
        domProps: {
          "innerHTML": _vm._s(c.cpnContent)
        }
      }) : _vm._e(), _vm._v(" "), (c.cpnCode === 'vip') ? _c('i-teacher', {
        attrs: {
          "info": c,
          "dataInfo": c.cpnData
        }
      }) : _vm._e(), _vm._v(" "), (c.cpnCode === 'cal') ? _c('daily', {
        attrs: {
          "color": _vm.color,
          "dataInfo": c.cpnData,
          "width": 989
        },
        on: {
          "search": _vm.searchFun
        }
      }) : _vm._e(), _vm._v(" "), (c.cpnCode === 'info') ? _c('consultation', {
        attrs: {
          "color": _vm.color,
          "data": c.cpnData
        }
      }) : _vm._e(), _vm._v(" "), (c.cpnCode == 'live') ? _c('livecom', {
        attrs: {
          "padding": false,
          "showTop": false,
          "width": 188,
          "showNum": 5,
          "data": c
        }
      }) : _vm._e()], 1) : _vm._e()
    })], 2)
  })), _vm._v(" "), (_vm.search && _vm.searchData) ? _c('div', [_c('dailySearch', {
    attrs: {
      "color": _vm.color,
      "propData": _vm.searchData
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.bannerImg) ? _c('div', {
    ref: "bannerImg",
    staticStyle: {
      "text-align": "center",
      "margin-top": "70px",
      "font-size": "0"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.tmpBottomImg,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('login', {
    attrs: {
      "color": _vm.color,
      "showBox": _vm.showBox
    },
    on: {
      "close": _vm.login2
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-765e7395"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tpl1/index.vue
// module id = 814
// module chunks = 10